import { combineReducers } from '@reduxjs/toolkit'
import { get } from './get'
import { update } from './update'

export const fiat = combineReducers({
  get,
  update
})
